const MDAllyAboutUs = (function($) {
    
    const controller = new ScrollMagic.Controller();
    const EO = Elastic.easeOut.config;

    const onInit = function() {

    	initPageScrollElements();
    
		jQuery('body').css('opacity', 1);
		console.log('page loaded :: About Us ');
		
		initMobileSlider();
	}

	function initPageScrollElements() {
			
		// gsap.set( '.item04 .img01' , {objectFit:'cover' , objectFitSize:});
       // gsap.set( '.item04 .img02' , {objectFit:'cover'});
		const image01 = {
            name: 'image01',
            el: '.item04 .img01',
            trigger: {triggerElement: '.collective-insights' , triggerHook: 0.8 , duration:"150%" },
            gsap: gsap.fromTo( '.collective-insights .img01' , {y:50} , {y:-50 , ease:Power1.easeInOut} ),
            pin : null,
            scene: null,
            inited : false,
            desktopOnly: false
        }
        image01.scene = MDAllyAnimations.add( image01 );
    

        const image02 = {
            name: 'image02',
            el: '.item04 .img02',
            trigger: {triggerElement: '.collective-insights' , triggerHook: 0.8 , duration:"150%" },
            gsap: gsap.fromTo( '.item04 .img02' , {y:-50 } , {y:50 , ease:Power1.easeOut} ),
            pin : null,
            scene: null,
            inited : false,
            desktopOnly: false

        }
        image02.scene = MDAllyAnimations.add( image02 );
       
		const maptl = gsap.timeline();
			maptl.add('start', '+=0');
			maptl.from( $(".stat-image path[data-name='highlight']") , 1 , {stagger:0.1 , fill:"#005ea6"} , 'start+=0' );
			maptl.from( $(".stat-image path[data-name='dollar']") , 1 , {scale:"-=0.5" , alpha:0 , transformOrigin:'50% 50%', ease:EO(0.6,1)} , 'start+=0.5' );

		const mapElement = {
			name: 'mapElement',
    		el: 'section.stats-block',
    		trigger: {triggerElement: 'section.stats-block' , triggerHook: 0.4  },
    		gsap: maptl,
    		pin : null,
    		scene: null,
    		inited : false,
    		desktopOnly: false
    	}
    	mapElement.scene = MDAllyAnimations.add( mapElement );


    	/**** insight elements *****/
    	// gsap.set( 'section.collective-insights .insight01 .insight-item img' , {height:'110%'} );
    	// gsap.set( 'section.collective-insights .insight02 .insight-item img' , {height:'110%'} );

    	const insight01 = {
			name: 'insight01',
    		el: '.insight01 .insight-item',
    		trigger: {triggerElement: 'section.collective-insights' , triggerHook: 0.8 , duration:"200%" },
    		gsap: gsap.fromTo( 'section.collective-insights .insight01 .insight-item' , {y:50} , {y:-20 , ease:Power1.easeInOut} ),
    		pin : null,
    		scene: null,
    		inited : false,
    		desktopOnly: true
    	}
    	insight01.scene = MDAllyAnimations.add( insight01 );


    	const insight02Ani = {
			name: 'insight02Ani',
    		el: 'section.collective-insights',
    		trigger: {triggerElement: 'section.collective-insights' , triggerHook: 0.8 , duration:"200%" },
    		gsap: gsap.fromTo( 'section.collective-insights .insight02 .insight-item' , {y:-50} , {y:100 , ease:Power1.easeOut} ),
    		pin : null,
    		scene: null,
    		inited : false,
    		desktopOnly: true
    	}
    	insight02Ani.scene = MDAllyAnimations.add( insight02Ani );

    	/*
		const insight01AniInner = {
			name: 'insight01AniInner',
    		el: 'section.collective-insights',
    		trigger: {triggerElement: 'section.collective-insights' , triggerHook: 0.8 , duration:"200%" },
    		gsap: gsap.fromTo( 'section.collective-insights .insight01 .insight-item img' , {yPercent:-10} , {yPercent:10 , ease:'none'} ),
    		pin : null,
    		scene: null,
    		inited : false
    	}
    	insight01AniInner.scene = MDAllyAnimations.add( insight01AniInner );
    	MDAllyAnimations.desktopOnly.push( insight01AniInner );


    	const insight02AniInner = {
			name: 'insight02AniInner',
    		el: 'section.collective-insights',
    		trigger: {triggerElement: 'section.collective-insights' , triggerHook: 0.8 , duration:"200%" },
    		gsap: gsap.fromTo( 'section.collective-insights .insight02 .insight-item img' , {yPercent:10} , {yPercent:-10 , ease:'none'} ),
    		pin : null,
    		scene: null,
    		inited : false
    	}
    	insight02AniInner.scene = MDAllyAnimations.add( insight02AniInner );
    	MDAllyAnimations.desktopOnly.push( insight02AniInner );
    	*/

    	MDAllyAnimations.update();
	}
	
	function initMobileSlider(){
		ResponsiveHelper.addRange({
			'..768': {
				on: function () {
					$(".about-us-team .mobile-items").on("init", function(event, slick){
						$(this).parent().find('.indicator').text(parseInt(slick.currentSlide + 1) + ' of ' + slick.slideCount);
					});
					
					$(".about-us-team .mobile-items").on("afterChange", function(event, slick, currentSlide){
						$(this).parent().find('.indicator').text(parseInt(slick.currentSlide + 1) + ' of ' + slick.slideCount);
					});

					$('.about-us-team .mobile-items').slick({
						dots: true,
						infinite: false,
						arrows: false,
						slidesToShow: 1,
						slidesToScroll: 1,
						variableWidth: true,
						cssEase: 'cubic-bezier(0.770, 0.000, 0.175, 1.000)',
						speed: 500
					});
				},
				off: function () {
					$('.about-us-team .mobile-items').slick('destroy');
				},
			},
		});
	}

    return {
    	init: onInit,
    }; 

})(jQuery);
